import type { StringGUID } from "@pdfking/tfunc"

// A field's DOM id doubles as its form path; the uuid only backs detached
// nodes with no path yet.
export const dom_id = (self: { path: string; uuid: StringGUID }): StringGUID =>
  (self.path || self.uuid) as StringGUID

export const child_path = (...segments: (string | number)[]): string => segments.join("/")
